import { Injectable } from '@angular/core';
import { User } from "../model/user";
import 'rxjs/add/operator/map'; 
import {Observable} from 'rxjs/Rx';

import { AngularFireAuth } from 'angularfire2/auth';
import { HttpClient,HttpHeaders  } from '@angular/common/http';
import * as firebase from 'firebase/app';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  //private api = 'http://localhost:8080/FlandresServices/';  
   
  private api = 'https://www.apps.jdagency.fr/FlandresServices/';  
  private params = new URLSearchParams();  

 

  constructor(private http: HttpClient,private _firebaseAuth: AngularFireAuth) { 
    this.params.set('format', 'json');  
    this.params.set('callback', 'JSONP_CALLBACK'); 
  }
 


  checkUserRight(idToken, idFirebaseUser):Observable<boolean>{

    const httpOptions = {
      headers: new HttpHeaders({
        'X-Firebase-Auth':  idToken
      })
    };
    const endPoint = 'user/connexion/'   + idFirebaseUser;
    // Returns response  
    return this.http.get(
                this.api + endPoint,
                httpOptions)
                .map((result:any) => result.success == "1")
                .catch((error:any) => Observable.throw('Server error'  || error ));
            
  }

  

  getUserConnected(idToken, idFirebaseUser):Observable<User> {

    const httpOptions = {
      headers: new HttpHeaders({
        'X-Firebase-Auth':  idToken
      })
    };

    const endPoint = 'user/' + idFirebaseUser;
    // Returns response  
    return this.http.get(
                this.api + endPoint,
                httpOptions)
                .map(res => User.fromJson(res))
                .catch((error:any) => Observable.throw('Server error'  || error ));
    
  }

}
